import { Chip, createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { setSideOne, setSideTwo } from "../playerCompare/store/actions";
import { Config } from "../playerCompare/store/types";
import { APIConstants } from "../utils/api/constants";
import { APIState } from "../utils/api/reducer";
import { useQueryParams } from "../utils/queryParams";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.white,
      fontFamily: "Roboto",
    },
    selectorWrapper: {
      display: "flex",
      flexDirection: "column",
    },
    selectorTitle: {
      textDecoration: "underline",
      fontSize: 24,
      fontWeight: 600,
      margin: "8px 0",
    },
    optionsWrapper: {
      display: "flex",
      "& div": {
        margin: "0 4px",
        cursor: "pointer",
        fontSize: 18,
        borderColor: "white",
      },
    },
    selected: {
      textDecoration: "underline",
      fontWeight: 700,
      color: theme.palette.common.white,
    },
    notSelected: {
      color: theme.palette.grey[500],
    },
  })
);

interface OwnProps {
  readonly config: APIState<Config>;
}

interface DispatchProps {
  readonly SetSideOne: (players: string[]) => void;
  readonly SetSideTwo: (players: string[]) => void;
}

type Props = OwnProps & DispatchProps;

const Settings = (props: Props) => {
  const { config, SetSideOne, SetSideTwo } = props;
  const classes = useStyles();
  const [site, setSite] = React.useState("dk");
  const [slate, setSlate] = React.useState("main");
  let queryParams = useQueryParams();
  const history = useHistory();
  const location = useLocation();
  const token = queryParams.get("token") || "";

  const handleSiteSelect = (site: string) => {
    SetSideOne([]);
    SetSideTwo([]);
    setSite(site);
    const params = new URLSearchParams({
      site: site,
      slate: slate,
      token: token,
    });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const handleSlateSelect = (slate: string) => {
    SetSideOne([]);
    SetSideTwo([]);
    setSlate(slate);
    const params = new URLSearchParams({
      site: site,
      slate: slate,
      token: token,
    });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  React.useEffect(() => {
    const siteQuery = queryParams.get("site") || "dk";
    const slateQuery = queryParams.get("slate") || "main";

    setSite(siteQuery);
    setSlate(slateQuery);
  }, []);

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.root}
      >
        {config.status === APIConstants.SUCCEEDED && (
          <Grid container item xs={12} sm={9}>
            <Grid
              container
              item
              xs={12}
              sm={config.data.slates?.length > 0 ? 6 : 12}
              alignItems="center"
              className={classes.selectorWrapper}
            >
              <div className={classes.selectorTitle}>Site</div>
              <div className={classes.optionsWrapper}>
                {config.data.sites.map((configSite, key) => (
                  <div key={configSite.id + key}>
                    <Chip
                      label={configSite.name}
                      onClick={() =>
                        handleSiteSelect(configSite.id.toLowerCase())
                      }
                      className={
                        site.toLowerCase() === configSite.id.toLowerCase()
                          ? classes.selected
                          : classes.notSelected
                      }
                      variant="outlined"
                    ></Chip>
                  </div>
                ))}
              </div>
            </Grid>
            {
              config.data.slates?.length > 0 && (
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  alignItems="center"
                  className={classes.selectorWrapper}
                >
                  <div className={classes.selectorTitle}>Slate</div>
                  <div className={classes.optionsWrapper}>
                    {config.data.slates.map((configSlate, key) => (
                      <div key={configSlate.id + key}>
                        <Chip
                          label={configSlate.name}
                          onClick={() =>
                            handleSlateSelect(configSlate.id.toLowerCase())
                          }
                          className={
                            slate.toLowerCase() === configSlate.id.toLowerCase()
                              ? classes.selected
                              : classes.notSelected
                          }
                          variant="outlined"
                        ></Chip>
                      </div>
                    ))}
                  </div>
                </Grid>
              )
            }
          </Grid>
        )}
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {
  SetSideOne: setSideOne,
  SetSideTwo: setSideTwo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
